"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveUserSettings = saveUserSettings;
exports.fetchUserSettingsIfNeeded = exports.fetchUserSettings = void 0;

var _immutable = require("immutable");

var _ActionTypes = require("./ActionTypes");

var _UserSettings = require("../api/UserSettings");

var _logging = require("../utils/logging");

var _UserSettings2 = require("../selectors/UserSettings");

var _PortalMeta = require("./PortalMeta");

var _Auth = require("../selectors/Auth");

function saveUserSettings(userId) {
  var updateAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    var userSettings = (0, _UserSettings2.getUserSettings)(getState());
    userSettings = userSettings.merge(updateAttrs);
    dispatch({
      type: _ActionTypes.SAVE_USER_SETTINGS_ATTEMPTED,
      data: userSettings
    });
    (0, _UserSettings.saveSettings)(userId, userSettings).done();

    if ((0, _Auth.getIsUngatedForGameraMigration)(getState())) {
      dispatch((0, _PortalMeta.dualWriteUserSettingUpdate)(updateAttrs));
    }
  };
}

var fetchUserSettings = function fetchUserSettings(userId) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.FETCH_USER_SETTINGS_ATTEMPTED
    });
    return (0, _UserSettings.fetchSettings)(userId).then(function (userSettings) {
      dispatch({
        type: _ActionTypes.FETCH_USER_SETTINGS_SUCCEEDED,
        userSettings: userSettings
      });
      return userSettings;
    }).catch(function (err) {
      if (err.status === 404) {
        dispatch({
          type: _ActionTypes.FETCH_USER_SETTINGS_EMPTY
        });
        return (0, _immutable.Map)();
      }

      if (err.status) {
        (0, _logging.reportError)(err, {
          action: _ActionTypes.FETCH_USER_SETTINGS_FAILED
        });
      }

      dispatch({
        type: _ActionTypes.FETCH_USER_SETTINGS_FAILED
      });
      return (0, _immutable.Map)();
    });
  };
};

exports.fetchUserSettings = fetchUserSettings;

var fetchUserSettingsIfNeeded = function fetchUserSettingsIfNeeded() {
  return function (dispatch, getState) {
    if ((0, _UserSettings2.getUserSettingsHaveLoaded)(getState())) {
      return Promise.resolve((0, _UserSettings2.getUserSettings)(getState()));
    } else {
      return dispatch(fetchUserSettings((0, _Auth.getUserId)(getState())));
    }
  };
};

exports.fetchUserSettingsIfNeeded = fetchUserSettingsIfNeeded;